const aws = {
  region: 'eu-west-1',
  identityPoolId: 'eu-west-1:02f72d90-0e97-4d46-bba8-c65a5d0af104',
  userPoolId: 'eu-west-1_i2MXRXChp',
  userPoolClientId: '799pj2c85b4npglilc11peo8qk',
  productionManagementAppsyncEndpoint: 'https://ehjly7lz5fhjjgx7pj3nsktg3m.appsync-api.eu-west-1.amazonaws.com/graphql',
  userManagementAppsyncEndpoint: 'https://qjvkafo2oveqph6gqy7gixnyaq.appsync-api.eu-west-1.amazonaws.com/graphql',
};
export default aws;
